import React from 'react'
import styles from './HeaderForAuth.module.css'
import Logo from '../UI/Logo/Logo'
import { useNavigate } from 'react-router-dom'

const HeaderForAuth = () => {
  const navigate = useNavigate()

  const redirectToMainPage = () => {
    navigate('/')
  }
  return (
    <div className={styles.formHeaderBlock}>
      <Logo onClick={redirectToMainPage} />
    </div>
  )
}

export default HeaderForAuth
